export default "__VITE_ASSET__BpDE$5HC__"